














import { Component, Vue, Prop } from 'vue-property-decorator'
import AppDatatable from '@core/components/AppDatatable.vue'
import { CommissionStatementDTO } from '@core/pages/CommissionModule/api'
import { FormStructure } from '@master/model/structure/FormStructure'
import AppModal from '@core/components/AppModalV2.vue'
import AppForm from '@core/components/AppForm.vue'
import { FinancingPaymentStructure } from '@master/enum/AdviserFinancingEnum'
import { inject } from 'inversify-props'
import { IDateService } from '@master/services/IDateService'

@Component({
  components: {
    AppDatatable,
    AppModal,
    AppForm
  }
})
export default class TheCommissionStatement extends Vue {
    @inject()
  private dateService: IDateService

    @Prop({ default: false }) detailLoadingList: boolean
    @Prop({ default: false }) enableRowClick: boolean
    @Prop() data: CommissionStatementDTO[]
    @Prop() search
    @Prop() customCommissionColumn
    @Prop({ default: undefined }) customTableSort: {prop: string; order: 'descending' | 'ascending'}

    showStatementDetailsModal = false
    selectedToViewDetails: CommissionStatementDTO = null

    get tableData () {
      return this.data.map(record => {
        return {
          ...record,
          emit: true,
          displayCtm: this.dateService.format(record.ctm, 'YYYY-MM-DD'),
          displayPublished: record.published ? 'Published' : 'Unpublished',
          displayPaymentStructure: FinancingPaymentStructure[record?.paymentStructure] || ''
        }
      })
    }

    get fullCommissionDetailsColumn () {
      if (this.customCommissionColumn) return this.customCommissionColumn
      return this.defaultFullCommissionDetailsColumn
    }

    get sortingKey () {
      if (this.customTableSort) return this.customTableSort
      return { prop: 'displayCtm', order: 'descending' }
    }

    get defaultFullCommissionDetailsColumn () {
    // this is the full column list where it is used for the main details table, the popup modal and also csv export
    // this default to statement generator log page
    // any different from this, use custom prop instead
      return [
        {
          label: 'Payees',
          field: 'payee'
        },
        {
          label: 'Generated On',
          field: 'displayCtm',
          hide: () => !this.showStatementDetailsModal
        },
        {
          label: 'Batch',
          field: 'batch'
        },
        {
          label: 'Taxable(Non-Payable)',
          field: 'nonPayableAmount',
          type: 'currency',
          hide: () => !this.showStatementDetailsModal
        },
        {
          label: 'Open Balance',
          field: 'personalOpenBalance',
          type: 'currency'
        },
        {
          label: 'Personal Commission',
          field: 'personalCommission',
          type: 'currency'
        },
        {
          label: 'Income/Deduction',
          field: 'incomeDeductionAmount',
          type: 'currency'
        },
        {
          label: 'Payout Amount',
          field: 'personalPayoutAmount',
          type: 'currency'
        },
        {
          label: 'Close Balance',
          field: 'personalCloseBalance',
          type: 'currency'
        },
        {
          label: 'Open Balance',
          field: 'overridingOpenBalance',
          type: 'currency'
        },
        {
          label: 'Overriding Commission',
          field: 'overridingCommission',
          type: 'currency'
        },
        {
          label: 'Payout Amount',
          field: 'overridingPayoutAmount',
          type: 'currency'
        },
        {
          label: 'Close Balance',
          field: 'overridingCloseBalance',
          type: 'currency'
        },
        {
          label: 'Total Amount',
          field: 'totalEarnAmount',
          hide: () => !this.showStatementDetailsModal,
          type: 'currency'
        }, {
          label: 'Payment Structure',
          field: 'displayPaymentStructure',
          hide: () => !this.showStatementDetailsModal
        },
        {
          label: 'Status',
          field: 'displayPublished'
        }
      ]
    }

    get commissionRecordReportsColumn () {
    // to shown in main table
      return this.fullCommissionDetailsColumn.filter(column => !column.hide)
    }

    get statementModalStructure (): FormStructure<CommissionStatementDTO>[] {
    // this structure used for display into the modal dialog
      const formStructure = this.fullCommissionDetailsColumn.map(eachField => {
        if (eachField.field === 'overridingOpenBalance') {
          eachField.label = 'Overriding Open Balance'
        }
        if (eachField.field === 'overridingPayoutAmount') {
          eachField.label = 'Overriding Payout Amount'
        }
        if (eachField.field === 'overridingCloseBalance') {
          eachField.label = 'Overriding Close Balance'
        }
        return {
          label: eachField.label,
          key: eachField.field,
          type: eachField?.type,
          disabled: true,
          precision: eachField?.type === 'currency' ? 2 : undefined
        }
      })

      return formStructure
    }

    rowClick (event) {
      if (!this.enableRowClick) return
      this.$emit('statementClickCustom', event)
    }
}
